/**
 * @file ScrWeeklyLayout — themed shell for every /scr-weekly route. It provides
 * the `.scrw` root (which defines the --scrw-* design tokens) and renders the
 * matched child route. Kept intentionally minimal: the current-week page owns
 * its own header, and cross-page navigation will be added in a later step.
 */

import { Outlet } from 'react-router-dom';
import '../styles/scrWeekly.scss';

export function ScrWeeklyLayout() {
  return (
    <div className="scrw">
      <Outlet />
    </div>
  );
}
